import { Flex, Text } from "@chakra-ui/react";
import { SharpCornerBox } from "./SharpCornerBox";
import { BoxProps } from "@chakra-ui/react";
import { GiftThickIcon } from "../../icons/GiftThickIcon";
import { useTranslation } from "react-i18next";

interface GoldRewardBadgeProps extends BoxProps {
  fontSize?: string | number;
}

export function GoldRewardBadge({
  fontSize,
  ...props
}: GoldRewardBadgeProps) {
  const { t } = useTranslation();

  return (
    <SharpCornerBox
      corners={["topLeft", "bottomRight"]}
      background="blaze.600"
      borderWidth={0}
      opacity={0.95}
      {...props}
    >
      <Flex alignItems="center" gap="8px" py="4px">
        <GiftThickIcon boxSize="16px" />
        <Text
          fontSize={fontSize || "12px"}
          fontWeight="500"
          color="white"
          whiteSpace="nowrap"
        >
          {t("components.cards.goldRewardBadge.goldReward")}
        </Text>
      </Flex>
    </SharpCornerBox>
  );
}
